export default "__VITE_ASSET__RKP3BT$d__"